import { AxiosInstance } from "axios";
import { IResponseBody } from "../../Schemas/EndPoint";
import { IBlockNumberSchema } from "../../Schemas/BlockNumber";

export interface BlockNumbersListResponseBody extends IResponseBody {
  data: {
    block_numbers: IBlockNumberSchema;
  };
}

export class BlockNumbersDeleteRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath(blockNumberId: number) {
    return `/admin/block-numbers/${blockNumberId}/delete`;
  }

  async remove(blockNumberId: number): Promise<BlockNumbersListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.post(
        this.getPath(blockNumberId)
      );
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
